import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeft, ArrowRight } from "@air/next-icons";
import { ButtonGroup } from "@air/primitive-button-group";
import { IconButton } from "@air/primitive-icon-button";
import classNames from "classnames";
import { memo } from "react";
import { ASSET_MODAL_NEXT, ASSET_MODAL_NEXT_DISABLED, ASSET_MODAL_PREVIOUS, ASSET_MODAL_PREVIOUS_DISABLED } from "~/constants/testIDs";
export const PreviousAndNextNavigationArrows = /*#__PURE__*/ memo((param)=>{
    let { onPreviousClick, onNextClick, className } = param;
    const hasPrevious = !!onPreviousClick;
    const hasNext = !!onNextClick;
    return /*#__PURE__*/ _jsxs(ButtonGroup, {
        className: classNames("flex items-center", className),
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                color: "grey",
                icon: ArrowLeft,
                label: "Previous asset",
                onClick: onPreviousClick,
                disabled: !hasPrevious,
                "data-testid": hasPrevious ? ASSET_MODAL_PREVIOUS : ASSET_MODAL_PREVIOUS_DISABLED,
                size: "medium"
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                color: "grey",
                icon: ArrowRight,
                label: "Next asset",
                onClick: onNextClick,
                disabled: !hasNext,
                "data-testid": hasNext ? ASSET_MODAL_NEXT : ASSET_MODAL_NEXT_DISABLED,
                size: "medium"
            })
        ]
    });
});
PreviousAndNextNavigationArrows.displayName = "PreviousAndNextNavigationArrows";
